import PageHeader from './_page-header.js'
import EmptyContent from './_empty-content.js'
import FlexPane from './_flex-pane.js'

export default {
  name: 'InPlayPage',
  values: {
    documentHeadMetaFactory: undefined,
    showPageHeader: false,
    _mobile_showPageHeader: true,
    pageHeader: {
      configSet: PageHeader,
      configValues: {
        icon: {
          src: 'in-play-filled',
        },
      },
    },
    emptyContent: {
      configSet: EmptyContent,
      configValues: {},
    },
    secondaryContentContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    hideBreadcrumbs: false,
    _mobile_hideBreadcrumbs: true,
  },
  meta: {
    extendable: false,
  },
}
